import { css } from "styled-components";
import { FormFieldTitle } from "features/bots/common/styles";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

/**
 * New look: the bot form's field labels in the platform's label role
 * (12.5 / 500, the firm secondary grey) wherever the form is shown (page,
 * drawer, onboarding), 8px over their field.
 */
export const newLookFormScope = css`
  ${FormFieldTitle} {
    ${newLookType.label};
    color: ${(p) => getNewLookTokens(p.theme).secondary};
    min-height: 16px;
  }
`;
